// Helper function to adapt questions for minors
export const adaptQuestionForMinor = (question, isMinor) => {
  if (!isMinor) return question;
  
  // Create a copy of the question
  const adaptedQuestion = { ...question };
  
  // Map of question transformations for minors
  const minorTransformations = {
    // Hausarzt und Grundfragen
    "Wer ist Ihre Hausärztin oder Ihr Hausarzt?": "Wer ist die Hausärztin oder der Hausarzt Ihres Kindes?",
    "Befinden Sie sich zur Zeit in ärztlicher Behandlung?": "Befindet sich Ihr Kind zur Zeit in ärztlicher Behandlung?",
    "Aus welchem Grund sind Sie in Behandlung?": "Aus welchem Grund ist Ihr Kind in Behandlung?",
    "Haben Sie einen Pflegegrad?": "Hat Ihr Kind einen Pflegegrad?",
    "Welchen Pflegegrad haben Sie?": "Welchen Pflegegrad hat Ihr Kind?",
    "Nehmen Sie Medikamente ein?": "Nimmt Ihr Kind Medikamente ein?",
    
    // Herz-Kreislauf und Bluterkrankungen
    "Tragen Sie einen Herzschrittmacher?": "Trägt Ihr Kind einen Herzschrittmacher?",
    "Haben Sie einen Herzklappenfehler?": "Hat Ihr Kind einen Herzklappenfehler?",
    "Haben Sie einen künstlichen Herzklappenersatz?": "Hat Ihr Kind einen künstlichen Herzklappenersatz?",
    "Leiden Sie an einer Herz-Kreislauf-Erkrankung?": "Leidet Ihr Kind an einer Herz-Kreislauf-Erkrankung?",
    "An welcher Herz-Kreislauf-Erkrankung leiden Sie?": "An welcher Herz-Kreislauf-Erkrankung leidet Ihr Kind?",
    "Haben Sie Bluthochdruck?": "Hat Ihr Kind Bluthochdruck?",
    "Haben Sie eine Blutgerinnungsstörung?": "Hat Ihr Kind eine Blutgerinnungsstörung?",
    "Welche Art von Gerinnungsstörung haben Sie?": "Welche Art von Gerinnungsstörung hat Ihr Kind?",
    "Nehmen Sie Blutverdünner?": "Nimmt Ihr Kind Blutverdünner?",
    "Welche Blutverdünner nehmen Sie?": "Welche Blutverdünner nimmt Ihr Kind?",

    // Andere Erkrankungen
    "Haben Sie Diabetes (Zuckerkrankheit)?": "Hat Ihr Kind Diabetes (Zuckerkrankheit)?",
    "Welchen Diabetes-Typ haben Sie?": "Welchen Diabetes-Typ hat Ihr Kind?",
    "Kennen Sie Ihren aktuellen HbA1c-Wert?": "Kennen Sie den aktuellen HbA1c-Wert Ihres Kindes?",
    "Leiden Sie an einer Lungenerkrankung oder Asthma?": "Leidet Ihr Kind an einer Lungenerkrankung oder Asthma?",
    "An welcher Lungenerkrankung leiden Sie?": "An welcher Lungenerkrankung leidet Ihr Kind?",
    "Leiden Sie an Epilepsie?": "Leidet Ihr Kind an Epilepsie?",
    "Haben Sie einen grünen Star (Glaukom)?": "Hat Ihr Kind einen grünen Star (Glaukom)?",
    "Haben Sie eine Nierenerkrankung?": "Hat Ihr Kind eine Nierenerkrankung?",
    "An welcher Nierenerkrankung leiden Sie?": "An welcher Nierenerkrankung leidet Ihr Kind?",
    "Haben Sie eine Lebererkrankung?": "Hat Ihr Kind eine Lebererkrankung?",
    "Leiden Sie an Osteoporose?": "Leidet Ihr Kind an Osteoporose?",
    "Haben oder hatten Sie eine Tumorerkrankung?": "Hat oder hatte Ihr Kind eine Tumorerkrankung?",
    "Welche Art von Tumorerkrankung haben/hatten Sie?": "Welche Art von Tumorerkrankung hat/hatte Ihr Kind?",
    
    // Infektionserkrankungen
    "Haben Sie eine Creutzfeldt-Jakob-Erkrankung?": "Hat Ihr Kind eine Creutzfeldt-Jakob-Erkrankung?",
    "Sind Sie MRSA-Träger?": "Ist Ihr Kind MRSA-Träger?",
    "Haben Sie andere ansteckende Erkrankungen?": "Hat Ihr Kind andere ansteckende Erkrankungen?",
    "Welche ansteckenden Erkrankungen haben Sie?": "Welche ansteckenden Erkrankungen hat Ihr Kind?",
    
    // Allergien
    "Sind Sie allergisch gegen Penicillin?": "Ist Ihr Kind allergisch gegen Penicillin?",
    "Haben Sie andere Medikamentenallergien?": "Hat Ihr Kind andere Medikamentenallergien?",
    "Gegen welche Medikamente sind Sie allergisch?": "Gegen welche Medikamente ist Ihr Kind allergisch?",
    "Haben Sie Allergien gegen zahnärztliche Materialien?": "Hat Ihr Kind Allergien gegen zahnärztliche Materialien?",
    "Gegen welche zahnärztlichen Materialien sind Sie allergisch?": "Gegen welche zahnärztlichen Materialien ist Ihr Kind allergisch?",
    "Haben Sie schon einmal allergisch auf eine örtliche Betäubung reagiert?": "Hat Ihr Kind schon einmal allergisch auf eine örtliche Betäubung reagiert?",
    
    // Lebensstil
    "Rauchen Sie?": "Raucht Ihr Kind?",
    "Wie viele Zigaretten rauchen Sie pro Tag?": "Wie viele Zigaretten raucht Ihr Kind pro Tag?",
    
    // Frauen
    "Sind Sie schwanger?": "Ist Ihre Tochter schwanger?",
    "Stillen Sie derzeit?": "Stillt Ihre Tochter derzeit?",
    
    // Kontakt (bei Bedarf)
    "Möchten Sie Rechnungen per E-Mail erhalten?": "Möchten Sie Rechnungen für Ihr Kind per E-Mail erhalten?",
    
    // Alte Fragen (Kompatibilität)
    "Leiden Sie an Herzschrittmacher?": "Hat Ihr Kind einen Herzschrittmacher?",
    "Leiden Sie an Herzklappenfehler?": "Hat Ihr Kind einen Herzklappenfehler?",
    "Haben Sie einen Herzklappenersatz?": "Hat Ihr Kind einen Herzklappenersatz?",
    "Leiden Sie an Herzerkrankungen?": "Leidet Ihr Kind an Herzerkrankungen?",
    "Leiden Sie an Bluthochdruck?": "Leidet Ihr Kind an Bluthochdruck?",
    "Haben Sie Blutgerinnungsstörungen?": "Hat Ihr Kind Blutgerinnungsstörungen?",
    "Leiden Sie an Diabetes?": "Leidet Ihr Kind an Diabetes?",
    "Leiden Sie an Lungenerkrankungen?": "Leidet Ihr Kind an Lungenerkrankungen?",
    "Leiden Sie an Grünem Star (Glaukom)?": "Leidet Ihr Kind an Grünem Star (Glaukom)?",
    "Leiden Sie an Nieren-/Blasenerkrankungen?": "Leidet Ihr Kind an Nieren-/Blasenerkrankungen?",
    "Leiden Sie an Leber-/Gallenerkrankungen?": "Leidet Ihr Kind an Leber-/Gallenerkrankungen?",
    "Leiden Sie an Magen-/Darmerkrankungen?": "Leidet Ihr Kind an Magen-/Darmerkrankungen?",
    "Haben Sie Schilddrüsenerkrankungen?": "Hat Ihr Kind Schilddrüsenerkrankungen?",
    "Leiden Sie an Infektionskrankheiten?": "Leidet Ihr Kind an Infektionskrankheiten?",
    "Leiden Sie an Tumorerkrankungen?": "Leidet Ihr Kind an Tumorerkrankungen?",
    "Leiden Sie an Gelenkersatz/künstlichen Gelenken?": "Hat Ihr Kind Gelenkersatz/künstliche Gelenke?",
    "Haben Sie eine Allergie gegen Penicillin?": "Hat Ihr Kind eine Allergie gegen Penicillin?",
    "Haben Sie eine Allergie gegen andere Medikamente?": "Hat Ihr Kind eine Allergie gegen andere Medikamente?",
    "Haben Sie eine Allergie gegen Latex oder Pflaster?": "Hat Ihr Kind eine Allergie gegen Latex oder Pflaster?",
    "Haben Sie eine Allergie gegen örtliche Betäubungsmittel?": "Hat Ihr Kind eine Allergie gegen örtliche Betäubungsmittel?",
    "Stillen Sie?": "Stillt Ihre Tochter?",
    "Putzen Sie regelmäßig Ihre Zähne?": "Putzt Ihr Kind regelmäßig die Zähne?",
    "Haben Sie ein Bonusheft?": "Hat Ihr Kind ein Bonusheft?",
    "Verwenden Sie Zahnseide oder Zwischenraumbürsten?": "Verwendet Ihr Kind Zahnseide oder Zwischenraumbürsten?",
    "Waren Sie in den letzten 2 Jahren bei der Prophylaxe?": "War Ihr Kind in den letzten 2 Jahren bei der Prophylaxe?",
    "Haben Sie Zahnfleischbluten?": "Hat Ihr Kind Zahnfleischbluten?",
    "Haben Sie schon mal eine Parodontitisbehandlung bekommen?": "Hat Ihr Kind schon mal eine Parodontitisbehandlung bekommen?",
    "Waren Sie schon mal in kieferorthopädischer Behandlung?": "War Ihr Kind schon mal in kieferorthopädischer Behandlung?",
    "Knirschen oder pressen Sie mit den Zähnen?": "Knirscht oder presst Ihr Kind mit den Zähnen?",
    "Haben Sie Beschwerden im Kiefergelenk?": "Hat Ihr Kind Beschwerden im Kiefergelenk?"
  };
  
  // Transform the question text
  if (minorTransformations[adaptedQuestion.question]) {
    adaptedQuestion.question = minorTransformations[adaptedQuestion.question];
  }
  
  return adaptedQuestion;
};

// Transformiert Med-Doku Felder in patientengerechte Fragen
export const medicalQuestions = {
  // Seite 2: Allgemeine medizinische Fragen
  hausarztGrundfragen: {
    title: "Allgemeine medizinische Fragen",
    questions: [
      {
        field: "hausarzt",
        question: "Wer ist Ihre Hausärztin oder Ihr Hausarzt?",
        type: "text",
        required: false,  // EINZIGES optionales Feld
        placeholder: "Name und Ort (optional)"
      },
      {
        field: "arzt_behandlung",
        question: "Befinden Sie sich zur Zeit in ärztlicher Behandlung?",
        type: "yesno"
      },
      {
        field: "arzt_behandlung_detail",
        question: "Aus welchem Grund sind Sie in Behandlung?",
        type: "text",
        placeholder: "Grund der Behandlung",
        dependent: "arzt_behandlung",
        showIf: true
      },
      {
        field: "pflegegrad",
        question: "Haben Sie einen Pflegegrad?",
        type: "yesno"
      },
      {
        field: "pflegegrad_stufe",
        question: "Welchen Pflegegrad haben Sie?",
        type: "select",
        options: [
          { value: "", label: "Bitte wählen..." },
          { value: "1", label: "Pflegegrad 1" },
          { value: "2", label: "Pflegegrad 2" },
          { value: "3", label: "Pflegegrad 3" },
          { value: "4", label: "Pflegegrad 4" },
          { value: "5", label: "Pflegegrad 5" }
        ],
        dependent: "pflegegrad",
        showIf: true
      },
      {
        field: "medikamente",
        question: "Nehmen Sie Medikamente ein?",
        type: "yesno"
      },
      {
        field: "medikamente_eingabe",
        question: "Wie möchten Sie Ihre Medikamente angeben?",
        type: "radio",
        dependent: "medikamente",
        showIf: true,
        options: [
          {
            value: "text",
            label: "Medikamente eingeben",
            hasTextField: true,
            textField: {
              field: "medikamente_liste",
              placeholder: "Bitte alle Medikamente mit Dosierung auflisten\nz.B. Aspirin 100mg 1x täglich"
            }
          },
          {
            value: "foto",
            label: "Foto der Medikamentenliste hochladen",
            hasMedicationCapture: true
          }
        ]
      }
    ]
  },

  // Seite 3: Herz-Kreislauf und Bluterkrankungen
  herzKreislaufBlut: {
    title: "Herz-Kreislauf und Bluterkrankungen",
    questions: [
      // Herz-Kreislauferkrankungen (5 Fragen)
      {
        field: "herzschrittmacher",
        question: "Tragen Sie einen Herzschrittmacher?",
        type: "yesno"
      },
      {
        field: "herzklappenfehler",
        question: "Haben Sie einen Herzklappenfehler?",
        type: "yesno"
      },
      {
        field: "herzklappenersatz",
        question: "Haben Sie einen künstlichen Herzklappenersatz?",
        type: "yesno"
      },
      {
        field: "herzkrankheit",
        question: "Leiden Sie an einer Herz-Kreislauf-Erkrankung?",
        type: "yesno",
        helpText: "z.B. Herzinsuffizienz, Angina pectoris, Herzinfarkt"
      },
      {
        field: "herzkrankheit_detail",
        question: "An welcher Herz-Kreislauf-Erkrankung leiden Sie?",
        type: "text",
        placeholder: "Genaue Bezeichnung",
        dependent: "herzkrankheit",
        showIf: true
      },
      {
        field: "bluthochdruck",
        question: "Haben Sie Bluthochdruck?",
        type: "yesno"
      },
      // Bluterkrankungen (2 Fragen)
      {
        field: "blutgerinnung",
        question: "Haben Sie eine Blutgerinnungsstörung?",
        type: "yesno",
        helpText: "z.B. verstärkte Blutungsneigung"
      },
      {
        field: "blutgerinnung_detail",
        question: "Welche Art von Gerinnungsstörung haben Sie?",
        type: "text",
        placeholder: "Genaue Bezeichnung",
        dependent: "blutgerinnung",
        showIf: true
      },
      // Blutverdünner (wichtige medizinische Information)
      {
        field: "blutverduenner",
        question: "Nehmen Sie Blutverdünner?",
        type: "yesno",
        helpText: "z.B. Marcumar, Aspirin, Xarelto, Eliquis"
      },
      {
        field: "blutverduenner_detail",
        question: "Welche Blutverdünner nehmen Sie?",
        type: "text",
        placeholder: "z.B. Marcumar 3mg, Aspirin 100mg",
        dependent: "blutverduenner",
        showIf: true
      }
    ]
  },

  // Seite 4: Andere Erkrankungen (9 Fragen)
  andereErkrankungen: {
    title: "Andere Erkrankungen",
    questions: [
      {
        field: "diabetes",
        question: "Haben Sie Diabetes (Zuckerkrankheit)?",
        type: "yesno"
      },
      {
        field: "diabetes_typ",
        question: "Welchen Diabetes-Typ haben Sie?",
        type: "radio",
        dependent: "diabetes",
        showIf: true,
        options: [
          { value: "typ1", label: "Typ 1" },
          { value: "typ2", label: "Typ 2" }
        ]
      },
      {
        field: "diabetes_hba1c",
        question: "Kennen Sie Ihren aktuellen HbA1c-Wert?",
        type: "number",
        step: 0.1,
        placeholder: "z.B. 6.5",
        dependent: "diabetes",
        showIf: true,
        helpText: "Langzeitblutzuckerwert"
      },
      {
        field: "lunge",
        question: "Leiden Sie an einer Lungenerkrankung oder Asthma?",
        type: "yesno"
      },
      {
        field: "lunge_detail",
        question: "An welcher Lungenerkrankung leiden Sie?",
        type: "text",
        placeholder: "z.B. Asthma, COPD",
        dependent: "lunge",
        showIf: true
      },
      {
        field: "epilepsie",
        question: "Leiden Sie an Epilepsie?",
        type: "yesno"
      },
      {
        field: "glaukom",
        question: "Haben Sie einen grünen Star (Glaukom)?",
        type: "yesno"
      },
      {
        field: "niere",
        question: "Haben Sie eine Nierenerkrankung?",
        type: "yesno"
      },
      {
        field: "niere_detail",
        question: "An welcher Nierenerkrankung leiden Sie?",
        type: "text",
        placeholder: "Genaue Bezeichnung",
        dependent: "niere",
        showIf: true
      },
      {
        field: "leber",
        question: "Haben Sie eine Lebererkrankung?",
        type: "yesno",
        helpText: "z.B. Hepatitis, Leberzirrhose"
      },
      {
        field: "osteoporose",
        question: "Leiden Sie an Osteoporose?",
        type: "yesno"
      },
      {
        field: "tumor",
        question: "Haben oder hatten Sie eine Tumorerkrankung?",
        type: "yesno"
      },
      {
        field: "tumor_detail",
        question: "Welche Art von Tumorerkrankung haben/hatten Sie?",
        type: "text",
        placeholder: "Art und Zeitpunkt",
        dependent: "tumor",
        showIf: true
      }
    ]
  },

  // Seite 5: Infektionserkrankungen und Allergien
  infektionserkrankungenAllergien: {
    title: "Infektionen und Allergien",
    sections: [
      {
        title: "Infektionserkrankungen",
        questions: [
          {
            field: "creutzfeldt_jakob",
            question: "Haben Sie eine Creutzfeldt-Jakob-Erkrankung?",
            type: "yesno"
          },
          {
            field: "mrsa",
            question: "Sind Sie MRSA-Träger?",
            type: "yesno",
            helpText: "Multiresistente Staphylokokken"
          },
          {
            field: "sonstige_infektionen",
            question: "Haben Sie andere ansteckende Erkrankungen?",
            type: "yesno",
            helpText: "z.B. Hepatitis, HIV, Tuberkulose"
          },
          {
            field: "sonstige_infektionen_detail",
            question: "Welche ansteckenden Erkrankungen haben Sie?",
            type: "text",
            placeholder: "Genaue Bezeichnung",
            dependent: "sonstige_infektionen",
            showIf: true
          }
        ]
      },
      {
        title: "Allergien",
        questions: [
          {
            field: "allergie_penicillin",
            question: "Sind Sie allergisch gegen Penicillin?",
            type: "yesno"
          },
          {
            field: "allergie_medikamente",
            question: "Haben Sie andere Medikamentenallergien?",
            type: "yesno"
          },
          {
            field: "allergie_medikamente_detail",
            question: "Gegen welche Medikamente sind Sie allergisch?",
            type: "text",
            placeholder: "Medikamentennamen",
            dependent: "allergie_medikamente",
            showIf: true
          },
          {
            field: "allergie_dental",
            question: "Haben Sie Allergien gegen zahnärztliche Materialien?",
            type: "yesno"
          },
          {
            field: "allergie_dental_detail",
            question: "Gegen welche zahnärztlichen Materialien sind Sie allergisch?",
            type: "text",
            placeholder: "z.B. Nickel, Amalgam",
            dependent: "allergie_dental",
            showIf: true
          },
          {
            field: "allergie_lokalanaesthesie",
            question: "Haben Sie schon einmal allergisch auf eine örtliche Betäubung reagiert?",
            type: "yesno"
          }
        ]
      }
    ]
  },

  // Seite 6: Sonstiges und Frauen
  sonstigesFrauen: {
    title: "Sonstiges",
    sections: [
      {
        title: "Lebensstil",
        questions: [
          {
            field: "raucher",
            question: "Rauchen Sie?",
            type: "yesno",
            minAge: 16  // Erst ab 16 Jahren anzeigen
          },
          {
            field: "raucher_detail",
            question: "Wie viele Zigaretten rauchen Sie pro Tag?",
            type: "text",
            placeholder: "Anzahl pro Tag",
            dependent: "raucher",
            showIf: true,
            minAge: 16
          },
        ]
      },
      {
        title: "Frauen",
        showForGender: "w",
        minAge: 14,  // Sektion erst ab 14 Jahren
        questions: [
          {
            field: "schwanger",
            question: "Sind Sie schwanger?",
            type: "yesno",
            showForGender: "w",
            minAge: 14  // Erst ab 14 Jahren anzeigen
          },
          {
            field: "stillend",
            question: "Stillen Sie derzeit?",
            type: "yesno",
            showForGender: "w",
            minAge: 14  // Erst ab 14 Jahren anzeigen
          }
        ]
      }
    ]
  }
};

/// Stammdaten für NEUPATIENTEN (erweitert)
export const stammdatenNeupatient = {
  title: "Persönliche Daten",
  sections: [
    {
      title: "👤 Persönliche Angaben",
      questions: [
        {
          field: "anrede",
          question: "Anrede",
          type: "radio",
          required: true,
          options: [
            { value: "Herr", label: "Herr" },
            { value: "Frau", label: "Frau" },
            { value: "Divers", label: "Divers" }
          ]
        },
        {
          field: "vorname",
          question: "Vorname",
          type: "text",
          required: true,
          placeholder: "Ihr Vorname"
        },
        {
          field: "nachname",
          question: "Nachname",
          type: "text",
          required: true,
          placeholder: "Ihr Nachname"
        },
        {
          field: "geburtsdatum",
          question: "Geburtsdatum",
          type: "date",
          required: true,
          placeholder: "TT.MM.JJJJ"
        },
        {
          field: "geschlecht",
          question: "Geschlecht",
          type: "radio",
          required: true,
          options: [
            { value: "m", label: "Männlich" },
            { value: "w", label: "Weiblich" },
            { value: "d", label: "Divers" }
          ]
        }
      ]
    },
    {
      title: "📍 Adresse",
      questions: [
        {
          field: "strasse",
          question: "Straße und Hausnummer",
          type: "text",
          required: true,
          placeholder: "z.B. Hauptstraße 123"
        },
        {
          field: "plz",
          question: "Postleitzahl",
          type: "text",
          required: true,
          placeholder: "z.B. 39104",
          inputMode: "numeric"
        },
        {
          field: "ort",
          question: "Ort",
          type: "text",
          required: true,
          placeholder: "z.B. Magdeburg"
        }
      ]
    },
    {
      title: "📞 Kontakt",
      questions: [
        {
          field: "telefon",
          question: "Telefonnummer",
          type: "tel",
          required: true,
          inputMode: "numeric",
          placeholder: "z.B. 0391 123456"
        },
        {
          field: "email",
          question: "E-Mail-Adresse",
          type: "email",
          required: false,
          placeholder: "ihre.email@beispiel.de"
        }
      ]
    },
    {
      title: "🏥 Versicherung",
      questions: [
        {
          field: "versicherungsart",
          question: "Versicherungsart",
          type: "radio",
          required: true,
          options: [
            { value: "GKV", label: "Gesetzlich versichert (GKV)" },
            { value: "PKV", label: "Privat versichert (PKV)" }
          ]
        },
        {
          field: "krankenkasse",
          question: "Name der Krankenkasse",
          type: "text",
          required: false,
          placeholder: "z.B. AOK, TK, Barmer..."
        },
        {
          field: "beruf",
          question: "Beruf",
          type: "text",
          required: false,
          placeholder: "Ihr aktueller Beruf"
        }
      ]
    }
  ]
};

// Seite 1: Kontaktdaten (für BESTANDSPATIENTEN - nur Aktualisierung)
export const contactQuestions = {
  title: "Persönliche Daten und Kontaktinformationen",
  sections: [
    {
      title: "📍 Adresse",
      questions: [
        {
          field: "strasse",
          question: "Straße und Hausnummer",
          type: "text",
          required: true,
          placeholder: "z.B. Hauptstraße 123"
        },
        {
          field: "plz_ort",
          question: "PLZ und Ort",
          type: "plz_ort",
          required: true,
          plzField: "plz",
          ortField: "ort"
        }
      ]
    },
    {
      title: "👤 Persönliche Angaben",
      questions: [
        {
          field: "geburtsort",
          question: "Geburtsort",
          type: "text",
          required: true,
          placeholder: ""
        }
      ]
    },
    {
      title: "📞 Kontakt",
      questions: [
        {
          field: "telefon",
          question: "Telefonnummer",
          type: "tel",
          required: true,
          inputMode: "numeric",
          pattern: "[0-9\\s\\-\\+\\(\\)]*",
          placeholder: "z.B. 0391 123456"
        },
        {
          field: "email",
          question: "E-Mail-Adresse",
          type: "email",
          required: false,
          placeholder: "ihre.email@beispiel.de"
        },
        {
          field: "rechnung_email",
          question: "Möchten Sie Rechnungen per E-Mail erhalten?",
          type: "yesno",
          dependent: "email",
          showIf: (value) => value && value.includes('@')
        }
      ]
    }
  ]
};

// Hilft bei der Gruppierung und Navigation
export const questionGroups = [
  { id: 'contact', title: 'Anschrift und Kontaktdaten', data: contactQuestions },
  { id: 'hausarztGrundfragen', title: 'Allgemeine medizinische Fragen', data: medicalQuestions.hausarztGrundfragen },
  { id: 'herzKreislaufBlut', title: 'Herz-Kreislauf und Bluterkrankungen', data: medicalQuestions.herzKreislaufBlut },
  { id: 'andereErkrankungen', title: 'Andere Erkrankungen', data: medicalQuestions.andereErkrankungen },
  { id: 'infektionserkrankungenAllergien', title: 'Infektionen und Allergien', data: medicalQuestions.infektionserkrankungenAllergien },
  { id: 'sonstigesFrauen', title: 'Sonstiges', data: medicalQuestions.sonstigesFrauen }
];

// Hilfsfunktion um alle Felder zu extrahieren
export function getAllFields() {
  const fields = [];
  
  // Kontaktdaten
  if (contactQuestions.sections) {
    contactQuestions.sections.forEach(section => {
      section.questions.forEach(q => {
        if (q.type === 'plz_ort') {
          fields.push(q.plzField);
          fields.push(q.ortField);
        } else {
          fields.push(q.field);
        }
      });
    });
  } else if (contactQuestions.questions) {
    contactQuestions.questions.forEach(q => fields.push(q.field));
  }
  
  // Medizinische Fragen
  Object.values(medicalQuestions).forEach(section => {
    if (section.questions) {
      section.questions.forEach(q => fields.push(q.field));
    } else if (section.sections) {
      section.sections.forEach(subsection => {
        subsection.questions.forEach(q => fields.push(q.field));
      });
    }
  });
  
  return fields;
}

// Prüft ob eine Frage angezeigt werden soll basierend auf Abhängigkeiten
export function shouldShowQuestion(question, formData, patient) {
  // Check if question should be hidden based on patient flag
  if (question.hideIfPatientFlag && patient) {
    if (patient[question.hideIfPatientFlag] === true) {
      return false;
    }
  }

  // Check age-based visibility (NEU)
  if (question.minAge && patient?.age != null) {
    if (patient.age < question.minAge) {
      return false;
    }
  }

  // Check gender-based visibility
  if (question.showForGender && patient) {
    const patientGender = patient.geschlecht || patient.gender;
    if (patientGender && patientGender.toLowerCase() !== question.showForGender.toLowerCase()) {
      return false;
    }
  }

  // Check dependency-based visibility
  if (!question.dependent) return true;

  const dependentValue = formData[question.dependent];

  if (typeof question.showIf === 'function') {
    return question.showIf(dependentValue);
  }

  return dependentValue === question.showIf;
}

// Prüft ob eine Sektion angezeigt werden soll (für Geschlechts- und Alters-spezifische Sektionen)
export function shouldShowSection(section, patient) {
  // Check age-based visibility (NEU)
  if (section.minAge && patient?.age != null) {
    if (patient.age < section.minAge) {
      return false;
    }
  }

  // Check gender-based visibility
  if (!section.showForGender || !patient) return true;

  const patientGender = patient.geschlecht || patient.gender;
  if (!patientGender) return true;

  return patientGender.toLowerCase() === section.showForGender.toLowerCase();
}